import { render, staticRenderFns } from "./d-mobile-card.vue?vue&type=template&id=4b52cc25&"
import script from "./d-mobile-card.vue?vue&type=script&lang=js&"
export * from "./d-mobile-card.vue?vue&type=script&lang=js&"
import style0 from "./d-mobile-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports